import { faCheck, faShieldBlank , faXmark} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';

const useStyles = makeStyles((theme) => {
  return {}
})

const StackedGreenShieldCheck = () => {
  return (
    <span className="fa-stack fa-fw fa-2xs">
      <FontAwesomeIcon icon={faShieldBlank} color="green" className="fa-stack-2x" />
      <FontAwesomeIcon icon={faCheck} inverse className="fa-stack-1x" />
    </span>
  )
}

const StackedRedShieldError = () => {
  return (
    <span className="fa-stack fa-fw fa-2xs">
      <FontAwesomeIcon icon={faShieldBlank} color="red" className="fa-stack-2x" />
      <FontAwesomeIcon icon={faXmark} inverse className="fa-stack-1x" />
    </span>
  )
}

export {StackedGreenShieldCheck, StackedRedShieldError}